import * as schemas from '@tunein/reporting-schemas';
import { mapKeys, mapValues } from 'es-toolkit';
import { Validator } from '../Validator';
export const tuneInEventValidators = mapValues(mapKeys(schemas, (_, key) => `validate${key}`), (v) => new Validator(v).validate);
